import React from "react";
import ReactDOM from "react-dom";
import { ScrollableContent, TopActionButtons, TopActionsAndScrollableContentContainer } from "../TopActionsAndScrollableContentContainer";
import './styles.css';

//
// A resuable component for a sliding drawer which opens up from the right side of the screen. The sliding drawer ispositioned at the top right of the parent div its placed in.
// Options:
//      - OpenDrawer: boolean controlling the state of the drawer. Drawer displays when true.
//      - onClose: Func called when there is a trigger to close the drawer i.e. the closed button or a click outside the drawer.
//                 For Correct functionality, onClose must aslo set OpenDrawer to false.
//

interface CustomCloseButtonOptions {
    className: string;
    localizedText: string;
}

interface Options {
    openDrawer: boolean;
    hasCta?: boolean;
    ctaTitle?: string;
    ctaCallback?: () => void;
    onClose: () => void;
    drawerTitle?: string | JSX.Element;
    customCloseButtonOptions?: CustomCloseButtonOptions,
    preventCloseOnModalClick?: boolean;
}

export class SlidingDrawer extends React.PureComponent<Options> {
    // ===============================================================================

    private drawerRef: React.RefObject<HTMLDivElement>;

    // ===============================================================================

    constructor(props: Options) {
        super(props);
        this.drawerRef = React.createRef<HTMLDivElement>();
    }

    // ===============================================================================

    public componentDidUpdate(prevProps: Options) {
        // Add click event listener if drawer is going from closed to open
        if (this.props.openDrawer && !prevProps.openDrawer) { 
            document.addEventListener("click", this.closeDrawer_click);
        }
    }

    // ===============================================================================

    public render() {
        const className = this.props.customCloseButtonOptions ? this.props.customCloseButtonOptions.className : "btn btn-default btn-close";
        const innerElementOrString = this.props.customCloseButtonOptions ? this.props.customCloseButtonOptions.localizedText : <span className="glyphicon glyphicon-remove" />;

        return (
            <div className={"tn-sliding-drawer tn-section" + (this.props.hasCta ? " tn-sliding-drawer-with-footer" : "") + (this.props.openDrawer ? "" : " drawer-closed")} ref={this.drawerRef}>
                <TopActionsAndScrollableContentContainer shouldMakeTnSection={false}>
                    <div className="tn-section-heading-row tn-section-row tn-sliding-drawer-heading-row">
                        <div className="tn-section-col-12">
                            <h1 tab-index="-1" className="sliding-drawer-title">{this.props.drawerTitle} <button className={className + " sliding-drawer-close-button"} onClick={e => this.closeDrawer(e)}>{innerElementOrString}</button></h1>
                        </div>
                    </div>
                    <ScrollableContent>
                        {this.props.children}
                    </ScrollableContent>
                </TopActionsAndScrollableContentContainer>
                {this.props.hasCta &&
                    <div className="sliding-drawer-footer">
                        <button onClick={this.props.ctaCallback} className="btn btn-toxnot-primary">{this.props.ctaTitle}</button>
                    </div>
                }
            </div>
        );
    }

    // ===============================================================================

    private closeDrawer = (e: React.MouseEvent) => {
        this.props.onClose();
        document.removeEventListener("click", this.closeDrawer_click);
    }

    // ===============================================================================

    private closeDrawer_click = (e: MouseEvent) => {
        if (this.props.preventCloseOnModalClick) {
            if (e.target !== null) {
                if ((e.target as HTMLElement).classList.value.indexOf("modal") > -1 || (e.target as HTMLElement).closest(".modal") !== null) {
                    return;
                }
            }
        }

        //If already closed do nothing
        if (!this.props.openDrawer) {
            return;
        }

        //If the click i.e. e is in the Ref(drawer), do nothing
        if (this.drawerRef.current && this.drawerRef.current.contains(e.target as Node)) {
            return;
        }

        this.props.onClose();
        document.removeEventListener("click", this.closeDrawer_click);
    }
}